import { Dispatch, SetStateAction } from "react"
import { HistoryType } from "../../enums/historyType"


export type SendSolutionType = {
    id?: number,
    type?: HistoryType,
    setSeeTabs: Dispatch<SetStateAction<boolean>>
}

export interface Evidence {
    evidenceTypeId: number;
    originalname: string;
    url: string;
}

export interface EvidenceTypeData {
    value?: Record<string, { name: string; url: string }>;
}

export const EVIDENCE_TYPES = {
    IMAGE: {
        id: 1,
        key: 'image',
        description: 'Imagen',
        accept: '.png,.jpg,.jpeg',
        types: ['png', 'jpg', 'jpeg']
    },
    VIDEO: {
        id: 2,
        key: 'video',
        description: 'Video',
        types: []
    },
    SIGN: {
        id: 3,
        key: 'sign',
        description: 'Firma'
    },
    FILE: {
        id: 4,
        key: 'file',
        description: 'Documento',
        types: ['pdf', 'csv', 'docx', 'xlsx', 'pptx', 'txt']
    },
    CAMERA: {
        id: 6,
        key: 'camera',
        description: 'Cámara',
        types: ['png', 'jpg', 'jpeg']
    },
    VIDEO_GALLERY: {
        id: 7,
        key: 'video_gallery',
        description: 'Video (Galeria)',
        types: ['mp4', 'wmv', 'wma']
    },

}
